export class TranslationKeys {
    static readonly RegistrationFailed = 'RegistrationFailed';
    static readonly CancelRegistrationError = 'CancelRegistrationError';
    static readonly CommunicationError = 'CommunicationError';
    static readonly RefreshPage = 'RefreshPage';
    static readonly AnonymousAccessNotAllowedError = 'AnonymousAccessNotAllowedError';
    static readonly EventCapacityExceeding = 'EventCapacityExceeding';
    static readonly EventCapacityReached = 'EventCapacityReached';
}
